import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Mail, Linkedin } from 'lucide-react';
import CONFIG from '../../../../config';
import { useI18n } from '../../../../hooks/useInternationalization';

const Footer = () => {
  const { t } = useI18n();
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigation = (sectionId, fallbackPath = null) => {
    // If we're on the home page, scroll to section
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to home page with hash, or to fallback path
      if (fallbackPath) {
        navigate(fallbackPath);
      } else {
        navigate(`/#${sectionId}`);
        // After navigation, scroll to section
        setTimeout(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      }
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/logo.png" alt="StudySmith" className="footer-logo-image" style={{backgroundColor: 'white', padding: '8px', borderRadius: '8px'}} />
              <span className="footer-logo-text">{CONFIG.app.name}</span>
            </Link>
            <p className="footer-description">
              {t('footer.description')}
            </p>
          </div>
          
          <div className="footer-links">
            <div className="footer-section">
              <h4>{t('footer.sections.product')}</h4>
              <ul>
                <li><button onClick={() => handleNavigation('features')} className="footer-link-button">{t('footer.links.features')}</button></li>
                <li><button onClick={() => handleNavigation('how-it-works')} className="footer-link-button">{t('footer.links.howItWorks')}</button></li>
                <li><Link to="/pricing">{t('footer.links.pricing')}</Link></li>
                <li><button onClick={() => handleNavigation('faq')} className="footer-link-button">{t('footer.links.faq')}</button></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>{t('footer.sections.company')}</h4>
              <ul>
                <li><Link to="/about">{t('footer.links.about')}</Link></li>
                <li><Link to="/contact">{t('footer.links.contact')}</Link></li>
                <li><Link to="/privacy">{t('footer.links.privacy')}</Link></li>
                <li><Link to="/terms">{t('footer.links.terms')}</Link></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>{t('footer.sections.connect')}</h4>
              <div className="social-links">
                <a href={CONFIG.social.linkedin} className="social-link" target="_blank" rel="noopener noreferrer">
                  <Linkedin size={20} />
                </a>
                <a href={`mailto:${CONFIG.app.contactEmail}`} className="social-link">
                  <Mail size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; {new Date().getFullYear()} {CONFIG.app.name}. {t('footer.copyright')}</p>
          </div>
          <div className="footer-made-with">
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 